/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobOutcomeNextFileObject } from "./JobOutcomeNextFileObject";
export const JobOutcomeNextFiles = core.serialization.object({
    files: core.serialization.list(JobOutcomeNextFileObject),
    label: core.serialization.string().optional(),
});
